import React from "react";
import { Row, Container, Col } from "react-bootstrap";
import {
  BuildIcon,
  DesignIcon,
  LaunchIcon,
  MaintenanceIcon,
  PlaneIcon,
  TestIcon,
} from "../../../app-constants";

function Workflowprocess() {
  return (
    <section
      className="workflow_process iot_procedure p-100"
      style={{ backgroundColor: "#F9F9F9" }}
    >
      <Container>
        <Row>
          <Col
            xs={12}
            md={10}
            lg={9}
            xl={8}
            xxl={8}
            className="m-auto text-center"
          >
            <h2>
              Our Simplified Procedure for{" "}
              <span>IoT Application Development</span>
            </h2>
            <p>
              The development of blockchain solutions is based on trust, making
              them solid, reliable, and of high scalability. Supplying the
              utmost clarity in every process, we take you through step by step
              and offer the highest quality of service that meets your company’s
              goals.
            </p>
          </Col>
        </Row>
        <Row>
          <Col xs={12} md={12} lg={12} xl={12} xxl={12} className="my-auto">
            <div className="workflow_main">
              <div className="workflow_process_item">
                <div className="workflow_process_img">{PlaneIcon}</div>
                <div className="workflow_process_content">
                  <h5>Discovery Phase</h5>
                  <p>
                    During the Discovery Phase, we perform a more detailed
                    analysis of the business expectations and IT solutions. This
                    entails a survey of key stakeholders, studying the
                    competition, and assessing the viability of the particular
                    IoT project.
                  </p>
                </div>
              </div>
              <div className="workflow_process_item">
                <div className="workflow_process_img">{DesignIcon}</div>
                <div className="workflow_process_content">
                  <h5>Strategic Planning</h5>
                  <p>
                    In Strategic Planning, we create a strategic plan that
                    details the technical architecture, the technology stack,
                    and the project schedule. It helps in achieving your
                    business objectives and sets directions or goals toward
                    development in this phase.
                  </p>
                </div>
              </div>
              <div className="workflow_process_item">
                <div className="workflow_process_img">{BuildIcon}</div>
                <div className="workflow_process_content">
                  <h5>Prototype Design</h5>
                  <p>
                    The Prototype Design phase involves generating detailed
                    non-working and working models to test design ideas and user
                    engagement. Performing this step helps to unveil rough edges
                    in the user experience and possible technical issues at the
                    onset.
                  </p>
                </div>
              </div>
              <div className="workflow_process_item">
                <div className="workflow_process_img">{TestIcon}</div>
                <div className="workflow_process_content">
                  <h5>Development Phase</h5>
                  <p>
                    During the Development Phase, the development of the coded
                    and built IoT application takes place using the agile
                    methodologies. To address IoT integration requirements, our
                    development team aims at building scalable, reliable, and
                    secure software components.
                  </p>
                </div>
              </div>
              <div className="workflow_process_item">
                <div className="workflow_process_img">{LaunchIcon}</div>
                <div className="workflow_process_content">
                  <h5>Integration and Testing</h5>
                  <p>
                    The Integration and Testing phase is vital in guaranteeing
                    the application runs optimally in the IoT environment. We
                    run unit tests, integration tests, and user acceptance tests
                    all to avoid negative results that may arise due to faults
                    in the software.
                  </p>
                </div>
              </div>
              <div className="workflow_process_item">
                <div className="workflow_process_img">{MaintenanceIcon}</div>
                <div className="workflow_process_content">
                  <h5>Deployment and Operations</h5>
                  <p>
                    During the Deployment & Operations phase, the IoT
                    application is deployed in the live environments with
                    minimal service disruptions. We get ready by creating the
                    structure, installing the managing tools, and doing the
                    final check for ready-to-launch setup.
                  </p>
                </div>
              </div>
            </div>
          </Col>
        </Row>
      </Container>
    </section>
  );
}

export default Workflowprocess;
